// BetaTech (2026-11-02, client request: "te b2c ne mobile mos me dal te pershkrimi specifikat po me kon kshtu si me
// selektu psh e para pershkrimi tani ne anen e djatht specifikat si tjeter page kshtu amo veq per mobile"): on phones
// (below 768px) the retail product page shows "Përshkrimi" | "Specifikat" as two tabs above the description and the
// "Specifikat" card, and only the chosen one; "Përshkrimi" first. From 768px nothing changes (the tab bar is hidden by
// CSS and both show, as before).
//
// Markup: snippets/beta-specs-layout.liquid (part "tabs", rendered by sections/product-details.liquid as the first child
// of div.beta-specs-layout) prints the tab bar only when the product has both a description with something to show and
// a "Specifikat" card, for retail visitors. Its inline script adds .beta-specs-layout--tabs to the wrapper while the
// page is parsed (so the tabs are there from the first paint: no layout shift) and takes the class off again at window
// load if this file did not run (both panels stacked, as without JavaScript). CSS: assets/beta-storefront.css 14d.
//
// This file: the ARIA tabs pattern (role tablist / tab / tabpanel, aria-selected, aria-controls, roving tabindex;
// ← / → / Home / End move the focus and select, "automatic activation", the panels are already on the page). The
// chosen tab is the wrapper's data-beta-specs-active ("description" | "specs") and is kept for the page (also over a
// resize across 768px and a re-render of the section in the theme editor). The panels get role="tabpanel" only on
// phones, where the tab bar shows. A switch keeps the tab bar where it was on the screen (no page jump); when a short
// panel leaves too little page below to scroll back by, blank space under it holds the place until it is off screen.
// The key handling (targetIndex) is unit-tested in tests/beta-specs-tabs.jxa.js; the DOM part only runs in a browser.
window.BetaSpecsTabs = window.BetaSpecsTabs || (function () {
  var NAMES = ['description', 'specs'];

  // The index of the tab a key moves to, or -1 for any other key. Arrows wrap around; right-to-left pages swap them.
  function targetIndex(key, current, count, rtl) {
    if (!(count > 0)) return -1;
    var index = current >= 0 && current < count ? current : 0;
    var forward = rtl ? ['ArrowLeft', 'Left'] : ['ArrowRight', 'Right'];
    var back = rtl ? ['ArrowRight', 'Right'] : ['ArrowLeft', 'Left'];
    if (forward.indexOf(key) !== -1) return (index + 1) % count;
    if (back.indexOf(key) !== -1) return (index - 1 + count) % count;
    if (key === 'Home') return 0;
    if (key === 'End') return count - 1;
    return -1;
  }

  // A stored or requested tab name, else the default "description".
  function normalize(name) {
    return NAMES.indexOf(name) !== -1 ? name : 'description';
  }

  return { targetIndex: targetIndex, normalize: normalize, memory: {} };
})();

(function () {
  if (typeof document === 'undefined' || window.BetaSpecsTabs.domReady) return;
  window.BetaSpecsTabs.domReady = true;

  var T = window.BetaSpecsTabs;
  var TABS_CLASS = 'beta-specs-layout--tabs';
  var phone = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  var bars = [];

  function panelsOf(wrapper) {
    var description = null;
    var specs = null;
    for (var i = 0; i < wrapper.children.length; i++) {
      var child = wrapper.children[i];
      if (!description && child.classList.contains('product-details__description')) description = child;
      if (!specs && child.hasAttribute('data-beta-specs')) specs = child;
    }
    return { description: description, specs: specs };
  }

  // role="tabpanel" (labelled by its tab, focusable) only while the tab bar shows; the card's own aria-labelledby
  // (its "Specifikat" heading) comes back from 768px.
  function applyRoles(bar) {
    var on = !phone || phone.matches;
    bar.tabs.forEach(function (tab) {
      var panel = bar.panels[tab.getAttribute('data-beta-specs-tab')];
      if (on) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.setAttribute('tabindex', '0');
      } else {
        panel.removeAttribute('role');
        panel.removeAttribute('tabindex');
        if (panel.betaSpecsLabel) panel.setAttribute('aria-labelledby', panel.betaSpecsLabel);
        else panel.removeAttribute('aria-labelledby');
      }
    });
  }

  // Blank space under a short panel (select): a min-height on the wrapper, set only by this file.
  function release(bar) {
    if (!bar.held) return;
    bar.held = false;
    bar.wrapper.style.minHeight = '';
    if (!bar.wrapper.getAttribute('style')) bar.wrapper.removeAttribute('style');
  }

  function select(bar, name, keepPlace) {
    name = T.normalize(name);
    var before = keepPlace ? bar.list.getBoundingClientRect().top : 0;
    var height = keepPlace ? bar.wrapper.getBoundingClientRect().height : 0;
    release(bar);
    bar.wrapper.setAttribute('data-beta-specs-active', name);
    T.memory[bar.list.id] = name;
    bar.tabs.forEach(function (tab) {
      var selected = tab.getAttribute('data-beta-specs-tab') === name;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
    });
    if (keepPlace) {
      // the panels differ in height; whatever the browser does with the scroll position, the tab bar stays put
      var shift = bar.list.getBoundingClientRect().top - before;
      if (Math.abs(shift) >= 1) window.scrollBy(0, shift);
      // a short panel on a page with little below it (no recommendations): the page got too short to scroll back
      // and the bar dropped. Blank space under the panel lets it scroll back: as much as is missing, and if the page
      // does not grow by that much (something below with a min-height takes it), the wrapper's height before the
      // switch, which the page had room for. It goes again on the next switch, from 768px and once below the screen
      for (var i = 0; i < 3; i++) {
        shift = bar.list.getBoundingClientRect().top - before;
        if (shift < 1) break;
        bar.held = true;
        var need = bar.wrapper.getBoundingClientRect().height + shift;
        bar.wrapper.style.minHeight = Math.ceil(i < 2 ? need : Math.max(need, height)) + 'px';
        window.scrollBy(0, bar.list.getBoundingClientRect().top - before);
      }
    }
  }

  // Gives the blank space back once it is below the bottom of the screen (the visitor scrolled up): only space nobody
  // sees goes, so nothing on the screen moves and the page never gets shorter than the screen needs.
  function trim() {
    var bottom = Math.max(window.innerHeight || 0, document.documentElement.clientHeight || 0);
    bars.forEach(function (bar) {
      if (!bar.held) return;
      if (!bar.list.isConnected) return release(bar);
      var rect = bar.wrapper.getBoundingClientRect();
      var room = Math.floor(rect.bottom - bottom);
      if (room < 1) return;
      var height = Math.max(0, Math.ceil(rect.height - room));
      bar.wrapper.style.minHeight = height + 'px';
      // the panel itself is taller than that: no blank space left
      if (bar.wrapper.getBoundingClientRect().height > height + 0.5) release(bar);
    });
  }

  // browsers fire scroll once per frame; nothing to do unless a bar holds blank space
  function onScroll() {
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].held) return trim();
    }
  }

  function setup(list) {
    if (list.betaSpecsTabs) return;
    var wrapper = list.parentElement;
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"][data-beta-specs-tab]'));
    var panels = wrapper ? panelsOf(wrapper) : {};
    if (!wrapper || tabs.length !== 2 || !panels.description || !panels.specs) {
      if (wrapper) wrapper.classList.remove(TABS_CLASS);
      return;
    }
    var bar = { list: list, wrapper: wrapper, tabs: tabs, panels: panels };
    list.betaSpecsTabs = bar;
    bars.push(bar);

    tabs.forEach(function (tab) {
      var panel = panels[tab.getAttribute('data-beta-specs-tab')];
      if (!panel.id) panel.id = tab.getAttribute('aria-controls');
      if (panel.betaSpecsLabel === undefined) panel.betaSpecsLabel = panel.getAttribute('aria-labelledby');
      tab.addEventListener('click', function () {
        select(bar, tab.getAttribute('data-beta-specs-tab'), true);
      });
    });

    list.addEventListener('keydown', function (event) {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      var current = tabs.indexOf(document.activeElement);
      if (current === -1) return;
      var rtl = getComputedStyle(list).direction === 'rtl';
      var next = T.targetIndex(event.key, current, tabs.length, rtl);
      if (next === -1) return;
      event.preventDefault();
      select(bar, tabs[next].getAttribute('data-beta-specs-tab'), true);
      tabs[next].focus();
    });

    wrapper.classList.add(TABS_CLASS);
    select(bar, T.memory[list.id] || wrapper.getAttribute('data-beta-specs-active'), false);
    applyRoles(bar);
  }

  function init(scope) {
    var lists = (scope || document).querySelectorAll('[data-beta-specs-tabs]');
    for (var i = 0; i < lists.length; i++) setup(lists[i]);
  }

  function onMedia() {
    bars = bars.filter(function (bar) { return bar.list.isConnected; });
    bars.forEach(function (bar) {
      release(bar);
      applyRoles(bar);
    });
  }

  if (phone) {
    if (phone.addEventListener) phone.addEventListener('change', onMedia);
    else if (phone.addListener) phone.addListener(onMedia);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  // theme editor: selecting the description block in the sidebar shows its tab
  document.addEventListener('shopify:block:select', function (event) {
    bars.forEach(function (bar) {
      if (bar.list.isConnected && event.target && bar.panels.description.contains(event.target)) select(bar, 'description', false);
    });
  });
})();
